import * as APPCONFIG from "../config/app-config.js";
import api from "./AuthAPI.js";
import Http from "./Http.js";

export const getHospitalData = (formValues) => {
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}hospital/hospitaldata`,
      data: JSON.stringify(formValues),
      headers: Http.AUTH_HEADERS()
    });
  };

  export const getHospitalById = (formValues) => {
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}hospital/getHospitalById`,
      data: JSON.stringify(formValues),
      headers: Http.AUTH_HEADERS()
    });
  };


  export const getAllHospitalName = (formValues) => {
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}hospital/getAllHospitalName`,
      data: JSON.stringify(formValues),
      headers: Http.AUTH_HEADERS()
    });
  };


  export const updateHospitalData = (formValues) => {
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}hospital/updateHospital`,
      data: formValues,
      headers: Http.AUTH_MULTIPART_HEADERS()
    });
  };
